import React, {Fragment} from "react";
import Slider, { Range } from "rc-slider";


const sliderHandle = props => {
    const { value, dragging, index, offset,suffix, ...restProps } = props;
    const positionStyle = {
      position: "absolute",
      left: `${offset}%`
    };
    return (
      <Fragment key={index}>
        <div className="rc-slider-tooltip" style={positionStyle}>
          {value}{" "}{suffix}
        </div>
        <Slider.Handle value={value} offset={offset}  {...restProps} />
      </Fragment>
    );
  };

export class SliderTooltip extends React.Component {
  render() {
      const suffix = this.props.suffix;
      return (
        // <Slider  handle={this.props.handle || sliderHandle} {...this.props} />
          <Slider handle={props => sliderHandle({ ...props, suffix })} {...this.props} />
      )
  }
}


export class RangeTooltip extends React.Component {
  render() {
      return (
        <Range handle={this.props.handle || sliderHandle} {...this.props}/>
      )
  }
}